import { Component, input } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { TooltipButtonComponent } from '../../../../components/button/tooltip-button.component';
import { OpenWindowDirective } from '../../../../components/open-window/open-window.directive';
import { OverlayComponent } from '../../../../components/overlay/overlay.component';

@Component({
  selector: 'td-wb-lti-assumptions-tooltip',
  templateUrl: 'goal-assumptions-tooltip.component.html',
  styleUrls: ['goal-assumptions-tooltip.component.scss'],
  imports: [
    TooltipButtonComponent,
    TranslatePipe,
    TranslateDirective,
    OverlayComponent,
    OpenWindowDirective
  ]
})
export class GoalAssumptionsTooltipComponent {
  readonly sectionId = input<string>(undefined);
  readonly position = input<string>('center-top');
}

